module.exports = __webpack_public_path__ + "img/avatar-1.6fbdb038.png";